import React, { PureComponent } from 'react'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
class ExpiredModal extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={kedo.t('Expired')}
                contentProps={{ dividers: true }}
                actions={
                    <StyledButton
                        onClick={() => {
                            location.href = '/subscriptions'
                        }}
                        // variant="success"
                    >
                        {kedo.t('Renew')}
                    </StyledButton>
                }
            >
                <>{kedo.t('subscription_expired')}</>
            </AppDialog>
        )
    }
}

export default ExpiredModal
